import axios from 'axios'

function getRandomColor() {
    var letters = '0123456789ABCDEF';
    var color = '#';
    for (var i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
}

//Default values
const state = {
    convFromActive: null,
    convFromPassive: null,
    leadSourceDistribution: null,
    salesFunnel: null,
    statusDistribution: null,
    totalCalls: null,
    form: {
        countries: [],
        sources: [],
        contacts: [],
        sales_modular: '',
        date: '',
        chart: '',
        chart_item: '',
    },
    modal: {
        show: false,
        chart_title: ''
    }
}

//Mutations voor de data voor de chart in de goede vorm te zetten
const mutations = {
    'GET_CHART_CONV_FROM_ACTIVE'(state, serverdata) {
        state.convFromActive = {
            labels: (serverdata.length == 0) ? ['No results'] : Object.keys(serverdata),
            datasets: [
                {
                    backgroundColor: (serverdata.length == 0) ? ['empty'] : ['gray', 'lightgreen'],
                    data: (serverdata.length == 0) ? [100] : Object.values(serverdata),
                    hoverBorderWidth: 8,
                }
            ]
        }
    },
    'GET_CHART_CONV_FROM_PASSIVE'(state, serverdata) {
        state.convFromPassive = {
            labels: (serverdata.length == 0) ? ['No results'] : Object.keys(serverdata),
            datasets: [
                {
                    backgroundColor: (serverdata.length == 0) ? ['empty'] : ['orange', 'gray'],
                    data: (serverdata.length == 0) ? [100] : Object.values(serverdata),
                    hoverBorderWidth: 8,
                }
            ]
        }
    },
    'GET_LEAD_SOURCE_DISTRIBUTION'(state, serverdata) {
        let labels = []
        let values = []
        let colors = []
        for (var key in serverdata) {
            if (serverdata[key].lead_source == null){
                labels.push('Not assigned')
            } else {
                labels.push(serverdata[key].lead_source)
            }

            values.push(serverdata[key].total)
            colors.push(getRandomColor())
        }

        state.leadSourceDistribution = {
            labels: (serverdata.length == 0) ? ['No results'] : labels,
            datasets: [
                {
                    backgroundColor: (serverdata.length == 0) ? ['#666666'] :colors,
                    data: (serverdata.length == 0) ? [100] : values,
                    hoverBorderWidth: 8,
                }
            ]
        }
    },
    'GET_STATUS_DISTRIBUTION'(state, serverdata) {
        let labels = []
        let values = []
        let colors = [];

        for (var key in serverdata) {
            labels.push(serverdata[key].status)
            values.push(serverdata[key].total)
            switch(serverdata[key].status){
                case "Active":
                    colors.push('orange')
                    break;
                case "Hold":
                    colors.push('gray')
                    break;
                case "Passive":
                    colors.push('brown')
                    break;
                case "Project":
                    colors.push('lightgreen')
                    break;
                default:
                    colors.push(getRandomColor())
                    break;

            }
        }

        state.statusDistribution = {
            labels: (serverdata.length == 0) ? ['No results'] : labels,
            datasets: [
                {
                    backgroundColor: (serverdata.length == 0) ? ['empty'] : colors,
                    data: (serverdata.length == 0) ? [100] : values,
                    hoverBorderWidth: 8,
                }
            ]
        }
    },
    'GET_SALES_FUNNEL'(state, serverdata) {
        let labels = []
        let values = []

        for (var key in serverdata) {
            labels.push(key)
            values.push(Math.round(serverdata[key]))
        }
        state.salesFunnel = {
            labels: labels,
            datasets: [
                {
                    backgroundColor: ['orange', 'darkgreen', 'lightgreen'],
                    data: values,
                    hoverBorderWidth: 8,
                }
            ]
        }
    },
    'GET_TOTAL_CALLS'(state, serverdata) {
        state.totalCalls = {
            total: serverdata.total
        }
    },
    'GET_CHART_MODAL'(state, data) {
        state.modal.show = true
        state.modal.chart_title = data.chart_title
    },
    'CLOSE_CHART_MODAL'(state) {
        state.modal.show = false
        state.form.chart = ''
        state.form.chart_item = ''
    },
    'GET_CHART_MODAL_DATA'(state, data) {
        state.form.chart = data.chart
        state.form.chart_item = data.chart_item
    }
}

//Data van de API ophalen en daarna mutations oproepen om deze data in de goede vorm te gieten
const actions = {
    CALL_CHART_DATA: async (context, payload) => {
        //Format sources for return to api
        let sources = []
        for(var key in payload.sources){
            sources.push(payload.sources[key].name)
        }

        return axios.post(process.env.VUE_APP_API_URL + 'items/data', {
            countries: payload.countries,
            sources: sources,
            contact:  (payload.contacts.id) ? payload.contacts.id : '',
            start_date: (payload.date) ? payload.date.start : '',
            end_date: (payload.date) ? payload.date.end : '',
            sales_modular: (payload.sales_modular.length == 0) ? '' : payload.sales_modular
        })
            .then((res) => {
                context.commit('GET_CHART_CONV_FROM_ACTIVE', res.data['conv-from-active'])
                context.commit('GET_CHART_CONV_FROM_PASSIVE', res.data['conv-from-passive'])
                context.commit('GET_LEAD_SOURCE_DISTRIBUTION', res.data['lead-source-distribution'])
                context.commit('GET_SALES_FUNNEL', res.data['sales-funnel'])
                context.commit('GET_STATUS_DISTRIBUTION', res.data['status-distribution'])
                context.commit('GET_TOTAL_CALLS', res.data['total-calls'])
            })
    },
    CALL_CHART_MODAL_DATA: async (context, payload) => {
        context.commit('GET_CHART_MODAL', payload)
        context.commit('GET_CHART_MODAL_DATA', payload)
    },
    CLOSE_CHART_MODAL: async (context) => {
        context.commit('CLOSE_CHART_MODAL')
        context.commit('TABLE_RESET')
    },
}

//Getters voor eenvoudig de data op te vragen in de components
const getters = {
    CHART_CONV_FROM_ACTIVE: state => {
        return state.convFromActive;
    },
    CHART_CONV_FROM_PASSIVE: state => {
        return state.convFromPassive;
    },
    CHART_LEAD_SOURCE_DISTRIBUTION: state => {
        return state.leadSourceDistribution;
    },
    CHART_SALES_FUNNEL: state => {
        return state.salesFunnel;
    },
    CHART_STATUS_DISTRIBUTION: state => {
        return state.statusDistribution;
    },
    CHART_TOTAL_CALLS: state => {
        return state.totalCalls;
    },
    CHART_MODAL: state => {
        return state.modal;
    },
    CHART_FORM: state => {
        return state.form;
    },
}

export default {
    state,
    mutations,
    actions,
    getters
}
